import React from 'react';
import {
  Label,
} from 'reactstrap';
import _ from 'lodash';
import Services from '../services';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';

const KartyaGeneralasForm = props => {
  const {
    formKartyaTipus,
    formPrefix,
    formMennyiseg,
    formMegjegyzes,
    handleSelectInputChange,
  } = props;

  const loadKartyaTipusOptions = (input, callback) => {
    Services.listKartyaTipus(true, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!input && !formKartyaTipus && res[0].length === 1) {
          handleSelectInputChange(res[0][0], 'formKartyaTipus'); 
        }
      }
    });
  }

  const renderForm = () => {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12 mb-1" style={{paddingTop: '8px'}}>
            <SelectField
              variant='async'
              label='Kártyatípus:'
              name="formKartyaTipus"
              id="formKartyaTipus"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => {
                handleSelectInputChange(v, 'formKartyaTipus'); 
                handleSelectInputChange(v ? v.prefix: null, 'formPrefix');
              }}
              loadOptions={_.debounce(loadKartyaTipusOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={formKartyaTipus}
              defaultOptions
              isClearable
              required
            />
          </div>
          <div className="col-md-6">
           <RFField
              label="Prefix: "
              disabled
              name={"formPrefix"}
              value={formPrefix}
            />
          </div>
          <div className="col-md-6">
            <RFField
              label="Mennyiség: "
              name={"formMennyiseg"}
              value={formMennyiseg}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <RFField
              label="Megjegyzés: "
              style={{height: '50px'}}
              type="textarea"
              name={"formMegjegyzes"}
              value={formMegjegyzes}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        {renderForm()}
      </div>
    </div>
  );
}

export default KartyaGeneralasForm;